import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { accountApi } from "../api/account";
import authSliceReducer from "./redux_auth/authSlice";
import { installAppLockAuthStateBridge } from "./appLockAuthStateBridge";
import { createIOSInstallationSessionMiddleware } from "../utils/native/installationAssociation";

export const store = configureStore({
  reducer: {
    [accountApi.reducerPath]: accountApi.reducer,
    auth: authSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      createIOSInstallationSessionMiddleware(),
      accountApi.middleware
    ),
});

setupListeners(store.dispatch);

// A no-op in a normal browser; see appLockAuthStateBridge.js.
installAppLockAuthStateBridge(store);
